/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Wed Jun 05 2024
*  File : MembershipController.ts
*******************************************/

import { BuyMembershipOptions } from "../sdk/ClientSdkPublicInterface.js";

export enum MembershipType {
    SELF_MONTHLY = "self_monthly",
    SELF_YEARLY = "self_yearly",
    GIFT_MONTHLY = "gift_monthly",
    GIFT_YEARLY = "gift_yearly",
}

export function isGift(type: MembershipType){
    return type == MembershipType.GIFT_MONTHLY || type == MembershipType.GIFT_YEARLY;
}

export const API_LOGIN_HASH = "apilogin";

export interface MembershipController {
    
    redirectToMembershipBuyPage(newTab: boolean);

    redirectToMembershipGiftPage(newTab: boolean);

    redirectToRedeemGiftPage(subscriptionId: string, userId: string, checkId: string, newTab: boolean);

    redirectToMembershipManagementPage(sub: string, newTab: boolean);

    getMembershipManagementLink(sub: string): Promise<string>;

    redirectToDirectProductBuyPage(type: MembershipType, options?: BuyMembershipOptions);

    loginRequested(): boolean;
}